import { genericPromise2 } from 'utils/ActionUtils'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import i18n from 'simple-react-i18n'

const FileAction = {
    createDir: (path, cb = () => { }) => {
        return (dispatch) => {
            return genericPromise2(ApplicationConf.files.system.createDir(), {
                method: 'POST',
                body: { path },
            })
                .then(json => {
                    if (json && json.error) {
                        dispatch(ToastrAction.error(json.error || i18n.createError))
                    } else {
                        dispatch(ToastrAction.success(i18n.elementCreateSuccess))
                        cb()
                    }
                    return json
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.createError} : ${err}`))
                    dispatch(ToastrAction.error(i18n.createError))
                })
        }
    },

    deleteDir: (path, cb = () => { }) => {
        return (dispatch) => {
            return genericPromise2(ApplicationConf.files.system.deleteDir(), {
                method: 'DELETE',
                body: { path },
            })
                .then(json => {
                    if (json && json.error) {
                        dispatch(ToastrAction.error(json.error || i18n.deleteError))
                    } else {
                        dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                        cb()
                    }
                    return json
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.deleteError} : ${err}`))
                    dispatch(ToastrAction.error(i18n.deleteError))
                })
        }
    },

    deleteFile: (path, cb = () => { }) => {
        return (dispatch) => {
            return genericPromise2(ApplicationConf.files.system.deleteFile(), {
                method: 'DELETE',
                body: { path },
            })
                .then(json => {
                    if (json && json.error) {
                        dispatch(ToastrAction.error(json.error || i18n.deleteError))
                    } else {
                        dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                        cb()
                    }
                    return json
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.deleteError} : ${err}`))
                    dispatch(ToastrAction.error(i18n.deleteError))
                })
        }
    },

    uploadFile: (dirPath, filename, content, cb = () => { }, noToaster = false) => {
        return (dispatch) => {
            return genericPromise2(ApplicationConf.files.system.uploadFile(), {
                method: 'POST',
                body: { dirPath, filename, content },
            })
                .then(json => {
                    if (json && json.error) {
                        if (!noToaster) dispatch(ToastrAction.error(json.error || i18n.addError))
                    } else {
                        if (!noToaster) dispatch(ToastrAction.success(i18n.addSuccess))
                        cb()
                    }
                    return json
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.addError} : ${err}`))
                    if (!noToaster) dispatch(ToastrAction.error(i18n.addError))
                })
        }
    },

    zipDir: (path, cb = () => { }) => {
        return (dispatch) => {
            return genericPromise2(ApplicationConf.files.system.zipDir(), {
                method: 'POST',
                body: { path },
            })
                .then(json => {
                    if (json && json.error) {
                        dispatch(ToastrAction.error(json.error || i18n.zipDirError))
                    } else {
                        cb(json.zipPath)
                    }
                    return json
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.zipDirError} : ${err}`))
                    dispatch(ToastrAction.error(i18n.zipDirError))
                })
        }
    },
}

export default FileAction